import { Nav } from "./Com2.style";

export const Com2 = ({ selected, setSelected }) => {
  return (
    <Nav.Wrapper>
      <Nav.BtnWrapper>
        <Nav.Btn selected={selected === 1} onClick={() => setSelected(1)}>
          스케치 월렛&페이
        </Nav.Btn>
        <Nav.Btn selected={selected === 2} onClick={() => setSelected(2)}>
          거래소 및 외부지갑
        </Nav.Btn>
      </Nav.BtnWrapper>
      {selected === 1 && (
        <Nav.Text>
          토큰 스왑을 위해 아래의 가이드를 따라해주세요
          <div></div>
        </Nav.Text>
      )}
    </Nav.Wrapper>
  );
};
